<h2 mat-dialog-title mat-dialog-draggable-title style="margin-bottom: 0px !important;">
    {{'alert.notify_sign_contract' | translate}} {{data.data.name}}
    <button type="button" class="close" aria-label="Close" (click)="onNoClick()">
      <span aria-hidden="true">&times;</span>
    </button>
</h2>
<mat-divider></mat-divider>
<div class="row" style="margin: 0px; padding: 0px;">
    <div style="margin: 5px 0">
        <span>Chọn người dùng, khách hàng cần nhắc ký</span>
    </div>
    <div class="col-12" style="margin: 0px; padding: 0px;">
        <div class="mat-table-container">
            <mat-table [dataSource]="listUser" class="mat-table-col-extra-sm">
                <!-- check -->
                <ng-container matColumnDef="check">
                    <mat-header-cell *matHeaderCellDef class="mat-header-cell-center check-col mat-cell-non-boder-right-bottom">
                        <mat-checkbox *ngIf="listUser && listUser.length > 0" [(ngModel)]="checkAll" (change)="checkAllDocument()" color="primary"></mat-checkbox>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element" class="mat-header-cell-center check-col mat-cell-non-boder-right-bottom" (click)="$event.stopPropagation()">
                        <mat-checkbox color="primary" [(ngModel)]="element.checked" (change)="onSelectionChange()">
                        </mat-checkbox>
                    </mat-cell>
                </ng-container>

                <!-- Full name -->
                <ng-container matColumnDef="userName">
                    <mat-header-cell *matHeaderCellDef style="width: 20%;" class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                        {{'headertable.user_name_sign_contract_notify' | translate}}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom" style="width: 20%;">
                        <span matTooltip="{{element.userName}}" class="fix-width" style="margin-left: -5px;">
          {{element.userName}}
        </span>
                    </mat-cell>
                </ng-container>

                <!-- Khach hang/noi bo -->
                <ng-container matColumnDef="isCreatedSide">
                    <mat-header-cell *matHeaderCellDef style="max-width: 20%;" class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                        {{'headertable.type_user_sign_contract_notify' | translate}}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element" matTooltip="{{ element.isCreatedSide === false ? 'Khách hàng' : 'Nội bộ' }}" class="mat-cell-non-boder-right-bottom number-cell-center" style="max-width: 20%;">
                        <span class="fix-width">{{ element.isCreatedSide === false ? 'Khách hàng' : 'Nội bộ' }}</span>
                    </mat-cell>
                </ng-container>

                <!-- Vai tro -->
                <ng-container matColumnDef="userRole">
                    <mat-header-cell *matHeaderCellDef style="max-width: 20%;" class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                        <span>
          {{'headertable.role_user_sign_contract_notify' | translate}}
        </span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element" matTooltip="{{element.userRole === 1 ? 'Ký duyệt' : (element.userRole === 2 ? 'Phê duyệt' : (element.userRole === 3 ? 'Ký nháy' : 'Ký duyệt'))}}" class="mat-cell-non-boder-right-bottom number-cell-center" style="max-width: 20%;">
                        <span class="fix-width">{{ element.userRole === 1 ? 'Ký duyệt' : (element.userRole === 2 ? 'Phê duyệt' : (element.userRole === 3 ? 'Ký nháy' : 'Ký duyệt')) }}</span>
                    </mat-cell>
                </ng-container>

                <!-- Hinh thuc gui canh bao -->
                <ng-container matColumnDef="isSendSms">
                    <mat-header-cell *matHeaderCellDef class="doc-status-col mat-cell-non-boder-right-bottom" style="max-width: 30%;">
                        {{'headertable.method_sign_contract_notify' | translate}}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element" class="doc-status-col number-cell-center" style="max-width: 30%;">
                        <div class="doc-status-all" 
                        >
                            <span style="margin-right: 30px;">
                                <mat-checkbox color="primary" [(ngModel)]="element.isSendSms" [checked]="!element.checked ? false: ''" [disabled]="!element.checked">
                                </mat-checkbox>
                                SMS
                            </span>
                            <span *ngIf="element.email">
                                <mat-checkbox color="primary" [(ngModel)]="sendEmail" disabled>
                                </mat-checkbox>
                                Email
                            </span>
                        </div>
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple class="element-row" [cdkDetailRow]="row">
                </mat-row>
            </mat-table>
        </div>
    </div>
</div>


<div mat-dialog-actions class="justify-content-center">

    <!--build icon, set default cancel-->
    <button mat-stroked-button color="primary" type="button" (click)="onNoClick()" cdkFocusInitial>
      <mat-icon class="mr-0">cancel</mat-icon>{{'button.cancel' | translate}}
    </button>
    <button class="ml-2" mat-raised-button color="primary" (click)="sendNotify()">
      <mat-icon class="mr-0">done</mat-icon>{{'button.send' | translate}}
    </button>
</div>